export default {
  sidebar: {
    administration: 'Administración',
    users: 'Usuarios',
    role: 'Roles',
    campus: 'Campus',
    closeContact: 'Contacto Estrecho',
  },
}
